import "@/App.css";
import { Navigation } from "./components/Navigation";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Process } from "./components/Process";
import { CTA } from "./components/CTA";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App bg-[#FAFAFA] min-h-screen">
      <Navigation />
      <main>
        <Hero />
        <Services />
        <Process />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
